


// import React, { useState, useEffect } from "react";
// import SimpleBar from "simplebar-react";
// import { useLocation, Link, useNavigate } from "react-router-dom";
// import { CSSTransition } from "react-transition-group";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import './Sidebar.css';
// import {
//   faBook,
//   faChartPie,
//   faUser,
//   faUsers,
//   faFileAlt,
//   faSignOutAlt,
//   faTable,
//   faTimes,
//   faList, faTags,faCity, faMapMarkerAlt, faLayerGroup , faBoxOpen,  
//   faPlusCircle, 
//   faClipboardList, faBuilding
// } from "@fortawesome/free-solid-svg-icons";
// import {
//   Nav,
//   Badge,
//   Image,
//   Button,
//   Dropdown,
//   Accordion,
//   Navbar,
// } from "@themesberg/react-bootstrap";

// import { useAuth } from "../AuthContext";
// import { Routes } from "../routes";
// import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";


// import logo_wemaza from "../assets/img/logo_wemaza.png";
// import Profile1 from "../assets/img/team/profile-picture-1.jpg";
import { getImageUrl } from "../utils/imageUrl";
import AxiosInstance from "../AxiosInstance";

// export default (props = {}) => {
//   const location = useLocation();
//   const { pathname } = location;

//   const [show, setShow] = useState(false);
//   const onCollapse = () => setShow(!show);

//   const [userData, setUserData] = useState(null);
//   const [avatarPreview, setAvatarPreview] = useState(Profile1);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const { logout } = useAuth();
//   const navigate = useNavigate();
//   // Composant NavItem déroulant
// const CollapsableNavItem = ({ title, icon, children, eventKey }) => {
//   const [open, setOpen] = useState(false);

//   return (
//     <Nav.Item>
//       <Nav.Link
//         onClick={() => setOpen(!open)}
//         aria-expanded={open}
//         className="d-flex justify-content-between align-items-center"
//       >
//         <span>
//           {icon && <FontAwesomeIcon icon={icon} className="sidebar-icon me-2" />}
//           <span className="sidebar-text">{title}</span>
//         </span>
//         <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} />
//       </Nav.Link>

//       <div className={`submenu ${open ? "d-block" : "d-none"} ms-3`}>
//         {children}
//       </div>
//     </Nav.Item>
//   );
// };


//   // Récupération des infos utilisateur au montage
//   useEffect(() => {
//     const fetchUser = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (!token) throw new Error("Utilisateur non authentifié.");

//         const res = await fetch("https://api.wemaza.com/api/users/profile", {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!res.ok) throw new Error(`Erreur serveur: ${res.status}`);

//         const data = await res.json();
//         const user = data.user || data;

//         setUserData(user);
//         setAvatarPreview(
//           user.avatar ? `https://api.wemaza.com/${user.avatar}` : Profile1
//         );
//       } catch (err) {
//         console.error("Erreur API:", err);
//         setError("Erreur lors du chargement des données utilisateur.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchUser();
//   }, []);

//   // Composant NavItem simple
//   const NavItem = ({
//     title,
//     link,
//     external,
//     target,
//     icon,
//     image,
//     badgeText,
//     badgeBg = "secondary",
//     badgeColor = "primary",
//   }) => {
//     const navItemClassName = link === pathname ? "active" : "";
//     const linkProps = external ? { href: link } : { as: Link, to: link };
//     const classNames = badgeText
//       ? "d-flex justify-content-start align-items-center justify-content-between"
//       : "";

//     return (
//       <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
//         <Nav.Link {...linkProps} target={target} className={classNames}>
//           <span>
//             {icon ? (
//               <span className="sidebar-icon">
//                 <FontAwesomeIcon icon={icon} />{" "}
//               </span>
//             ) : null}
//             {image ? (
//               <Image
//                 src={image}
//                 width={20}
//                 height={20}
//                 className="sidebar-icon svg-icon"
//               />
//             ) : null}
//             <span className="sidebar-text">{title}</span>
//           </span>
//           {badgeText ? (
//             <Badge
//               pill
//               bg={badgeBg}
//               text={badgeColor}
//               className="badge-md notification-count ms-2"
//             >
//               {badgeText}
//             </Badge>
//           ) : null}
//         </Nav.Link>
//       </Nav.Item>
//     );
//   };

//   // Contenu commun sidebar (pour desktop et mobile)
//   const SidebarContent = () => (
//     <>
//       <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
//         <div className="d-flex align-items-center">
//           <div className="user-avatar lg-avatar me-4">
//             <Image
//               src={avatarPreview}
//               className="card-img-top rounded-circle border-white"
//               alt="Avatar utilisateur"
//             />
//           </div>
//           <div className="d-block">
//             <h6>{userData ? userData.name : "Chargement..."}</h6>
//             <Button
//               variant="secondary"
//               size="xs"
//               className="text-dark"
//               onClick={() => {
//                 logout();
//                 navigate("/");
//               }}
//             >
//               <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Se déconnecter
//             </Button>
//           </div>
//         </div>
//         <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
//           <FontAwesomeIcon icon={faTimes} />
//         </Nav.Link>
//       </div>

//       <Nav className="flex-column pt-3 pt-md-0">
//         <div className="text-center mb-4">
//           <img
//             src={logo_wemaza}
//             alt="Logo Wemaza"
//             style={{ width: "150px", height: "30px" }}
//           />
//         </div>
//         <Dropdown.Divider className="my-3 border-indigo" />
//         {/* <NavItem
//           title="Tableau de bord"
//           link={Routes.DashboardOverview.path} 
//           icon={faChartPie}
//         /> */}
//         <NavItem title="Profil" icon={faUser} link={Routes.Settings.path} />
//         {/* <NavItem title="Type de categories" icon={faTags} link={Routes.BootstrapTables.path} /> */}
//         <NavItem
//         title="Gestion des villes"
//         icon={faBuilding}
//         iconSize="sm" // ou "xs", "lg", etc.
//         link={Routes.Villes.path}
//       />
//         <NavItem title="Arrondissements" icon={faMapMarkerAlt} link={Routes.Arrondissement.path} />
//         <NavItem title="Gestion des categories" icon={faLayerGroup} link={Routes.Categories.path} />
//         <NavItem title="Gestion des services" icon={faFileAlt} link={Routes.Transactions.path} />
//         <NavItem title="Gestion des agents" icon={faUsers} link={Routes.Agent.path} />
//         {/* <NavItem title="Gestion d'etapes" icon={faList} link={Routes.Etapeprocedure.path} /> */}
//         {/* <NavItem title="Demandes d'Ajout" icon={faTags} link={Routes.Demandes.path} /> */}
//         {/* <NavItem title="Demandes d'Etapes" icon={faTags} link={Routes.DemandesEtapes.path} /> */}
//         <CollapsableNavItem eventKey="components/" title="Demandes" icon={faBoxOpen}>
//           {/* Demandes d'ajout */}
//           <NavItem 
//             title="Ajout" 
//             icon={faPlusCircle} 
//             link={Routes.Demandes.path} 
//           />         

//           {/* Demandes liées aux procédures */}
//           <NavItem 
//             title="Etape"  
//             icon={faClipboardList}  
//             link={Routes.DemandesProcedure.path} 
//           />
//           <NavItem 
//             title="Devis"  
//             icon={faClipboardList}  
//             link={Routes.DemandesDevis.path} 
//           />
//         </CollapsableNavItem>



//       </Nav>
//     </>
//   );

//   // Rendu principal
//   return (
//     <>
//       {/* Navbar mobile */}
//       <Navbar
//         expand={false}
//         collapseOnSelect
//         variant="dark"
//         className="navbar-theme-primary px-4 d-md-none"
//       >
//         <Navbar.Brand
//           className="me-lg-5"
//           as={Link}
//           to={Routes.DashboardOverview.path}
//         >
//           <Image src={logo_wemaza} className="navbar-brand-light" alt="Logo Wemaza" />
//         </Navbar.Brand>
//         <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
//           <span className="navbar-toggler-icon" />
//         </Navbar.Toggle>
//       </Navbar>

//       {/* Sidebar mobile avec transition */}
//       <CSSTransition
//         timeout={300}
//         in={show}
//         classNames="sidebar-transition"
//         unmountOnExit
//       >
//         <SimpleBar className="sidebar d-md-none bg-primary text-white show">
//           <div className="sidebar-inner px-4 pt-3">
//             <SidebarContent />
//           </div>
//         </SimpleBar>
//       </CSSTransition>

//       {/* Sidebar desktop visible toujours */}
//       <SimpleBar className="sidebar d-none d-md-block bg-primary text-white">
//         <div className="sidebar-inner px-4 pt-3">
//           <SidebarContent />
//         </div>
//       </SimpleBar>
//     </>
//   );
// };

import React, { useState, useEffect } from "react";
import SimpleBar from "simplebar-react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './Sidebar.css';

import {
  faUser,
  faUsers,
  faFileAlt,
  faSignOutAlt,
  faTimes,
  faMapMarkerAlt,
  faLayerGroup,
  faBoxOpen,
  faPlusCircle,
  faClipboardList,
  faBuilding,
  faList,
  faLock,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";

import {
  Nav,
  Badge,
  Image,
  Button,
  Dropdown,
  Navbar,
} from "@themesberg/react-bootstrap";

import { useAuth } from "../AuthContext";
import { Routes } from "../routes";
import logo_wemaza from "../assets/img/logo_wemaza.png";
import Profile1 from "../assets/img/team/profile-picture-1.jpg";

export default () => {
  const location = useLocation();
  const { pathname } = location;

  const [show, setShow] = useState(false);
  const onCollapse = () => setShow(!show);

  const [userData, setUserData] = useState(null);
  const [avatarPreview, setAvatarPreview] = useState(Profile1);
  const [loading, setLoading] = useState(true);

  const [demandesCounts, setDemandesCounts] = useState({ ajout: 0, etapes: 0, devis: 0 });
  const [agentActiveServicesCount, setAgentActiveServicesCount] = useState(0);

  const { logout } = useAuth();
  const navigate = useNavigate();

  // 🔹 Récupération des infos utilisateur + compteurs de demandes
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await AxiosInstance.get("/api/users/profile");
        const user = res.data?.user || res.data;

        setUserData(user);
        setAvatarPreview(user.avatar ? getImageUrl(user.avatar) : Profile1);
      } catch (err) {
        console.error("Erreur API:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  // 🔹 Récupération des compteurs de demandes
  useEffect(() => {
    const fetchDemandesCounts = async () => {
      try {
        const [ajoutRes, etapesRes, devisRes] = await Promise.all([
          AxiosInstance.get("/api/demandes/ajout/list"),
          AxiosInstance.get("/api/demandes/etapes/list"),
          AxiosInstance.get("/api/demandes/devis/list"),
        ]);

        const ajoutList = ajoutRes.data?.data?.demandes || [];
        const etapesList = etapesRes.data?.data?.demandes || [];
        const devisList = devisRes.data?.data?.demandes || [];

        setDemandesCounts({
          ajout: ajoutList.filter(d => d.statut === "NON_TRAITE").length,
          etapes: etapesList.filter(d => d.statut === "NON_TRAITE").length,
          devis: devisList.filter(d => d.statut === "NON_TRAITE").length,
        });
      } catch (err) {
        console.error("Erreur lors du chargement des compteurs de demandes:", err);
      }
    };

    fetchDemandesCounts();
    // Rafraîchir toutes les 2 minutes
    const interval = setInterval(fetchDemandesCounts, 120000);
    return () => clearInterval(interval);
  }, []);

  // 🔹 Compteur de services en cours gérés par les agents
  useEffect(() => {
    const fetchAgentStats = async () => {
      try {
        const res = await AxiosInstance.get("/api/agents/statistics/overview");
        if (res.data?.success) {
          setAgentActiveServicesCount(res.data.data?.totalActiveServices || 0);
        }
      } catch (err) {
        console.error("Erreur lors du chargement des stats agents:", err);
      }
    };

    fetchAgentStats();
    const interval = setInterval(fetchAgentStats, 120000);
    return () => clearInterval(interval);
  }, []);

  // 🔹 NavItem simple
  const NavItem = ({
    title,
    link,
    external,
    target,
    icon,
    image,
    badgeText,
    badgeBg = "secondary",
    badgeColor = "primary",
  }) => {
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps} target={target}>
          <span>
            {icon && (
              <span className="sidebar-icon me-2">
                <FontAwesomeIcon icon={icon} />
              </span>
            )}
            {image && (
              <Image
                src={image}
                width={20}
                height={20}
                className="sidebar-icon svg-icon"
              />
            )}
            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText && (
            <Badge pill bg={badgeBg} text={badgeColor} className="ms-2">
              {badgeText}
            </Badge>
          )}
        </Nav.Link>
      </Nav.Item>
    );
  };

  // 🔹 NavItem déroulant
  const CollapsableNavItem = ({ title, icon, children, badgeText, badgeBg = "danger", badgeColor = "white" }) => {
    const [open, setOpen] = useState(false);
    return (
      <Nav.Item>
        <Nav.Link
          onClick={() => setOpen(!open)}
          className="d-flex justify-content-between align-items-center"
        >
          <span>
            {icon && <FontAwesomeIcon icon={icon} className="sidebar-icon me-2" />}
            <span className="sidebar-text">{title}</span>
          </span>
          <span className="d-flex align-items-center">
            {badgeText && (
              <Badge pill bg={badgeBg} text={badgeColor} className="me-2">
                {badgeText}
              </Badge>
            )}
            <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} />
          </span>
        </Nav.Link>

        <div className={`submenu ${open ? "d-block" : "d-none"} ms-3`}>
          {children}
        </div>
      </Nav.Item>
    );
  };

  // 🔹 Contenu de la sidebar
  const SidebarContent = () => (
    <>
      <div className="user-card d-flex d-md-none align-items-center justify-content-between pb-4">
        <div className="d-flex align-items-center">
          <div className="user-avatar lg-avatar me-3">
            <Image
              src={avatarPreview}
              className="card-img-top rounded-circle border-white"
              alt="Avatar utilisateur"
            />
          </div>
          <div className="d-block">
            <h6 className="mb-0">{userData ? userData.name : "Chargement..."}</h6>
            <Button
              variant="secondary"
              size="sm"
              className="text-dark mt-1"
              onClick={() => {
                logout();
                navigate("/");
              }}
            >
              <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Déconnexion
            </Button>
          </div>
        </div>
      </div>

      <Nav className="flex-column pt-3">
        <div className="text-center mb-4">
          <img
            src={logo_wemaza}
            alt="Logo Wemaza"
            style={{ width: "150px", height: "30px" }}
          />
        </div>
        <Dropdown.Divider className="my-3 border-indigo" />

        <NavItem title="Profil" icon={faUser} link={Routes.Settings.path} />
        <NavItem title="Gestion des villes" icon={faBuilding} link={Routes.Villes.path} />
        <NavItem title="Arrondissements" icon={faMapMarkerAlt} link={Routes.Arrondissement.path} />
        <NavItem title="Gestion des catégories" icon={faLayerGroup} link={Routes.Categories.path} />
        <NavItem title="Gestion de l'accès" icon={faLock} link={Routes.AccessConfig.path} />
        <NavItem title="Gestion des services" icon={faFileAlt} link={Routes.Transactions.path} />
        <NavItem
          title="Gestion des agents"
          icon={faUsers}
          link={Routes.Agent.path}
          badgeText={agentActiveServicesCount > 0 ? agentActiveServicesCount : null}
          badgeBg="danger"
        />

        <CollapsableNavItem
          title="Demandes"
          icon={faBoxOpen}
          badgeText={demandesCounts.ajout + demandesCounts.etapes + demandesCounts.devis || null}
        >
          <NavItem
            title="Ajout"
            icon={faPlusCircle}
            link={Routes.Demandes.path}
            badgeText={demandesCounts.ajout || null}
            badgeBg="danger"
          />
          <NavItem
            title="Étape"
            icon={faClipboardList}
            link={Routes.DemandesProcedure.path}
            badgeText={demandesCounts.etapes || null}
            badgeBg="danger"
          />
          <NavItem
            title="Devis"
            icon={faClipboardList}
            link={Routes.DemandesDevis.path}
            badgeText={demandesCounts.devis || null}
            badgeBg="danger"
          />
        </CollapsableNavItem>
      </Nav>
    </>
  );

  // 🔹 Rendu principal
  return (
    <>
      {/* Navbar mobile */}
      <Navbar
        bg="primary"
        variant="dark"
        expand={false}
        className="px-4 py-2 d-md-none justify-content-between align-items-center"
      >
        <Navbar.Brand as={Link} to={Routes.DashboardOverview.path}>
          <Image
            src={logo_wemaza}
            alt="Logo Wemaza"
            style={{ height: "32px", width: "auto" }}
          />
        </Navbar.Brand>

        {/* Bouton menu */}
        <Button
          variant="link"
          className="text-white border-0 p-0"
          onClick={onCollapse}
          aria-label="Ouvrir le menu"
        >
          <FontAwesomeIcon icon={show ? faTimes : faList} size="lg" />
        </Button>
      </Navbar>

      {/* Overlay sombre */}
      {show && (
        <div
          className="sidebar-overlay d-md-none"
          onClick={onCollapse}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.5)",
            zIndex: 998,
          }}
        ></div>
      )}


      <CSSTransition timeout={300} in={show} classNames="sidebar-transition" unmountOnExit>
        <div
          className="sidebar-mobile d-md-none"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "260px",
            backgroundColor: "#2C3E50",
            color: "white",
            zIndex: 999,
            overflowY: "auto",
            paddingBottom: "60px",
          }}
        >
          <div className="sidebar-inner px-4 pt-3">
            <SidebarContent />
          </div>
        </div>
      </CSSTransition>

      {/* Sidebar desktop */}
      <SimpleBar className="sidebar d-none d-md-block bg-primary text-white">
        <div className="sidebar-inner px-4 pt-3">
          <SidebarContent />
        </div>
      </SimpleBar>
    </>
  );
};
